<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ route.menuName }}</span>
      </div>
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" label="入库单号" v-if="getIsView()">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else>入库单号:{{ form.no }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="创建时间" prop="createdTime" v-if="getIsView()">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间"
                  style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>创建时间:{{   parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdUserName" label="发起人" v-if="getIsView()">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>发起人:{{ form.createdUserName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="ownerDeptName" label="所属科室" v-if="getIsView()">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>所属科室:{{ form.ownerDeptName }} </span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="applyOutStockNo" label="请领出库" v-if="getIsView()">
                <!-- + ' ' + (item.wardName ? item.wardName : '') -->

                <el-select v-model="form.applyOutStockNo" :disabled="!editMode" placeholder="请选择" filterable
                  :filter-method="getApplyList" @change="applyChange" style="width:100%">
                  <el-option v-for="item in applyList" :key="item.id"
                    :label="item.no + ' ' + item.applyDeptName "
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>请领出库:{{ form.applyOutStockNo }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="warehouseName" label="入库仓库" v-if="getIsView()">
                <el-select v-model="form.warehouseName" :disabled="!editMode" placeholder="请选择" filterable
                  :filter-method="getWarehousesBySessionWarehouseId" @change="warehouseChange" style="width:100%">
                  <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>入库仓库:{{ form.warehouseName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="inStockDeptName" label="入库科室" v-if="getIsView()">
                <el-input disabled v-model="form.inStockDeptName" ></el-input>
              </el-form-item>
              <span class="viewText" v-else>入库科室:{{ form.inStockDeptName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="category" label="入库类型" v-if="getIsView()">
                <el-radio-group disabled v-model="form.category">
                  <el-radio :label="0">普通入库</el-radio>
                  <el-radio :label="1">备货入库</el-radio>
                  <el-radio :label="2">跟台入库</el-radio>
                </el-radio-group>
              </el-form-item>
              <span class="viewText" v-else>入库类型:{{ form.category==1?'备货入库':form.category==2?'跟台入库':'普通入库' }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="date" label="入库日期" v-if="getIsView()">
                <el-date-picker :disabled="!editMode" v-model="form.date" size="small" type="date" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" placeholder="入库日期" style="width:100%"></el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>入库日期:{{  parseTime(new Date(form.date), "{y}-{m}-{d}") }} </span>
            </el-col>
          <!-- </el-row>
          <el-row> -->
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalNumber" label="总数量" v-if="getIsView()">
                <el-input disabled placeholder="请输入总数量" v-model="form.totalNumber" type="number"></el-input>
              </el-form-item>
              <span class="viewText" v-else>总数量:{{ form.totalNumber }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalAmount" label="总金额" v-if="getIsView()">
                <el-input type="number" disabled placeholder="请输入总金额" v-model="form.totalAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else>总金额:{{ form.totalAmount }} </span>
            </el-col>
            <el-col :span="12" :class="!getIsView()?'viewCol':''">
              <el-form-item label="备注" prop="remark" v-if="getIsView()">
                <el-input :disabled="!editMode" placeholder="备注" v-model="form.remark"></el-input>
              </el-form-item>
              <span class="viewText" v-else>备注:{{ form.remark }} </span>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">入库明细</span>
          </div>

          <div style="margin-top: 20px"></div>

          <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px" stripe
            :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="index" width="50" fixed> </el-table-column>

            <el-table-column prop="productName" label="产品" width="180" fixed></el-table-column>
            <el-table-column show-overflow-tooltip prop="specName" label="产品规格" width="130" fixed></el-table-column>
            <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productRegistCertName" label="产品注册证"
              width="180"></el-table-column>
            <el-table-column prop="brand" label="品牌" width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="supplierName" label="供应商" width="130"></el-table-column>
            <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" width="130"></el-table-column>
            <el-table-column prop="number" label="数量" width="120"></el-table-column>
            <el-table-column prop="refundNumber" label="退库数量" width="120"></el-table-column>
            <el-table-column prop="minUnit" label="最小单位" width="80"></el-table-column>
            <el-table-column prop="unit" label="包装单位" width="80"></el-table-column>
            <el-table-column prop="price" label="单价" width="120"></el-table-column>
            <el-table-column prop="amount" label="小计" width="120"></el-table-column>
            <el-table-column prop="packSpec" label="包装规格" width="120"></el-table-column>
            <el-table-column prop="locationName" label="货位" width="180">
              <template slot-scope="scope">
                <el-select :disabled="!editMode" placeholder="请选择货位" v-model="scope.row.locationName" filterable
                  @change="locationChange(scope.row)">
                  <el-option v-for=" item in STATIC_Locations" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="batch" label="批次号" width="120"></el-table-column>
            <el-table-column prop="validityDate" label="有效期" width="150">
              <template slot-scope="scope">
                {{ scope.row.validityDate ? parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}") : "" }}
              </template>
            </el-table-column>
            <el-table-column prop="longTime" label="长期" width="60">
              <template slot-scope="scope">
                {{ scope.row.longTime == 1 ? "是" : "否" }}
              </template>
            </el-table-column>
            <el-table-column prop="manufactureDate" label="生产日期" width="150">
              <template slot-scope="scope">
                {{ scope.row.manufactureDate ? parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d}") : "" }}
              </template>
            </el-table-column>
            <el-table-column prop="serialNo" label="序列号" width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="mainNo" label="主条码" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="traceNo" label="追溯码" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip v-if="system_setting.isUseRfid" prop="rfid" label="RFID"
              width="170"></el-table-column>

            <el-table-column show-overflow-tooltip prop="onlineNo" label="挂网号" width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productRegistCertNo" label="注册证号"
              width="180"></el-table-column>
            <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码"
              width="200"></el-table-column>

            <el-table-column prop="remark" label="备注" width="200"></el-table-column>
            <el-table-column fixed="right" prop="operation" label="标签详情" width="100">
              <template slot-scope="scope">
                <el-button type="text" v-if="scope.row.hasTagCode==1" v-preventReClick class="color-blue" @click="tagCodeView(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode && form.status!=0" class="btn primary" type="primary" v-preventReClick @click="proTemSave">暂 存</my-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button  v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确
        定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>
    <LabelDetailsDialog v-if="labelDetailsVisible" :open="labelDetailsVisible" :data="labelDetailsData" 
    @tagCodeDelete="tagCodeDelete"
    @close="closeLabelDetailsDialog"/>
    <PackageLabelDialog v-if="packageLabelVisible" :open="packageLabelVisible" :data="packageLabeData"
    @viewDetails="viewDetails"
     @tagCodeDelete="tagCodeDelete"
     @close="closePackageLabelDialog"/>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import tagCodeMixin from "@/mixin/tagCode-mixin";
import {
  GetApplyOutStockById,
  SpdGetDeptInStockById,
  SpdSaveDeptInStock,
  GetApplyOutStocks,
  SpdRejectDeptInStock,
  SaveDeptInStockTemp,
  GetWarehouses
} from "@/api";
import { StockCategoryOptions } from "@/enum";
// import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import LabelDetailsDialog from "@/components/labelDetails-dialog";
import PackageLabelDialog from "@/components/packageLabel-dialog";
export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin,tagCodeMixin],
  components: {
    // SelectTable,
    ApproveInfo,
    LabelDetailsDialog,
    PackageLabelDialog,
  },
  data () {
    return {
      GetDataAction: SpdGetDeptInStockById,
      SaveDataAction: SpdSaveDeptInStock,
      reject: SpdRejectDeptInStock,
      SaveTempAction: SaveDeptInStockTemp,
      form: {},
      StockCategoryOptions: StockCategoryOptions,
      rules: {
        warehouseName: [
          { required: true, message: '请选择入库仓库', trigger: 'blur' }
        ],
        date: [
          { required: true, message: '请选择入库日期', trigger: 'blur' }
        ],
        category: [
          { required: true, message: '请选择入库类型', trigger: 'blur' }
        ],
        supplierName: [{ required: true, message: '请选择供应商', trigger: 'blur' }]
      },
      childFormRules: {
        // manufactureDate: [{ required: true, message: "请选择生产日期", trigger: "blur" }],
        // validityDate: [{ required: true, message: "请选择有效期", trigger: "blur" }],
        // batch: [{ required: true, message: "请输入批次号", trigger: "blur" }],
        // productRegistCertId: [{ required: true, message: "请选择产品注册证", trigger: "blur" }],
        // packSpec: [{ required: true, message: "请输入包装规格", trigger: "blur" }],
        price: [
          { required: true, message: "请输入采购价", trigger: "blur" },
        ],
        number: [
          { required: true, message: "数量不能为空", trigger: "blur" },
          {
            type: "number",
            min: 0.01,
            message: "数量必须大于0",
            trigger: "blur",
          },
        ]
      },
      editMode: false,
      showWorkFlowInfo: false,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},

      applyList: [],
      // warehouseList: []
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }
    this.getApplyList('')
    // this.getWarehouses('')
    this.getWarehousesBySessionWarehouseId("")
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      this.GetDataAction({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.getLocations(this.form.warehouseId);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.initWorkFlowProperty(this.form);

      });
    },
    // 保存
    submit () {
      this.$store.dispatch('SetLoading',true)
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          this.$store.dispatch('SetLoading',false)
          return false;
        }
        
        this.SaveDataAction(this.form).then((res) => {
          this.loading = false;
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
          this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });
      });
    },
    resetForm () {
      this.form = {
        supplierId: "",
        deliveryTime: new Date(),
        // warehouseCategory: "1",
        // "warehouseId": this.userInfo.defaultWarehouseId,
        // warehouseName: this.userInfo.defaultWarehouseName,
        // warehouseManagerId: this.userInfo.defaultWarehouseManagerId,
        // warehouseManagerName: this.userInfo.defaultWarehouseManagerName,
        totalNumber: 0,
        totalAmount: 0,
        orderNo: "",
        category: 0,
        remark: "",
        "balanceStatus": 2,
        details: [],
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        inStockDeptName:this.system_setting.IsUseWard?`${this.mySessionStorage.getDeptName()} ${this.mySessionStorage.getWardName()} `:this.mySessionStorage.getDeptName(),
        inStockDeptId : this.mySessionStorage.getDeptId(),
        inStockWardId:this.system_setting.IsUseWard?this.mySessionStorage.getWardId():'',
        orgCode :sessionStorage.getItem('orgId'),
      };
      this.setDefaultWarehouseBySessionWarehouseId(2)
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm () {
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
      this.getProductList('')
      this.isScan = false;
    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
      this.isScan = false;
      this.getProductRegistCertDetails(this.childForm.productId);
    },

    resetDetailFormData () {
      let DeptName =  this.mySessionStorage.getDeptName()?this.mySessionStorage.getDeptName():''
        let WardName = this.mySessionStorage.getWardName()?this.mySessionStorage.getWardName():''
        this.form.
      this.childForm = {
        $index: this.form.details.length + 1,
        no: '',
        "productName": "",
        "specName": "",
        "manufacturerName": "",
        "locationName": "",
        "mainNo": "",
        "traceNo": "",
        supplierProductId: '',
        "productId": '',
        "specId": '',
        productRegistCertId: '',
        "productRegistCertNo": "",
        "onlineNo": "",
        "unit": "",
        "minUnit": "",
        "packSpec": "",
        "manufacturerId": '',
        "locationId": '',
        "manufactureDate": "",
        "batch": "",
        "validityDate": "",
        "serialNo": "",
        "number": 1,
        refundNumber: 0,
        "price": 0,
        "amount": 0,
        "remark": "",
        inStockDeptName:this.system_setting.IsUseWard?`${DeptName} ${WardName} `:DeptName,
        inStockDeptName : this.mySessionStorage.getDeptId(),
       
      };
    },
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    submitChildForm () {
      this.pushChildForm(true);
    },
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();
      // this.resetDetailFormData();

      this.getProductList('')
    },
    pushChildForm (close) {
      let result = true
      this.$refs["childForm"].validate((valid) => {
        result = valid
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        if (this.childForm.mainNo && this.childForm.traceNo) {
          var childForm = this.childForm
          // 添加行
          let arr = this.form.details.filter(
            (item) => item.mainNo == childForm.mainNo && item.traceNo == childForm.traceNo
          );

          // 添加行记录
          if (arr.length > 0) {
            // 存在则把列表的数据拿过来，并且数量加1
            this.form.details = this.form.details.map((item) => {
              if (
                item.mainNo == childForm.mainNo &&
                item.traceNo == childForm.traceNo
              ) {
                item.packSpec = childForm.packSpec;
                item.locationId = childForm.locationId;
                item.locationName = childForm.locationName;
                item.manufactureDate = childForm.manufactureDate;
                item.batch = childForm.batch;
                item.validityDate = childForm.validityDate;
                item.serialNo = childForm.serialNo;
                item.remark = childForm.remark;
                item.number = childForm.number;
                // item.unUseNumber = childForm.unUseNumber
                item.price = childForm.price;
                item.amount = childForm.amount;
              }
              return item;
            });
          } else {
            // 不存在则添加行记录
            var childForm = JSON.parse(JSON.stringify(this.childForm))
            childForm.$index = this.form.details.length + 1
            this.form.details.push(childForm)
          }
        }
        else {
          if (this.editChildren) {
            let item = this.form.details.find(
              (e) => e.$index == this.childForm.$index
            );
            Object.assign(item, this.childForm);
          }
          else {
            this.form.details.push(this.childForm)
          }
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
          this.count = 0;
        }
      });
      return result
    },
    // childNumberChange () {
    //   // this.childForm.notReceivedNumber = this.childForm.number
    //   // this.childForm.planOrderNumber = this.childForm.number
    //   // this.childForm.actualOrderNumber = this.childForm.number
    //   this.autoAmount();
    // },
    autoAmount () {
      // this.childForm.billingPrice = this.childForm.price
      this.childForm.amount = (this.childForm.number * this.childForm.price).toFixed(4) * 1;
      // this.childForm.unBillAmount = this.childForm.amount;
    },
    autoTotalAmount () {
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber.toFixed(3) * 1;
      this.form.totalAmount = totalAmount.toFixed(4) * 1;
      this.form.unBillNumber = totalNumber;
      this.form.unBillAmount = totalAmount;
    },

    // scan

    openScanner (ev) {
      this.count = 0;
      this.resetDetailFormData();
      this.isScan = true;
      this.openSubformModal = true;

      ev.target.blur();
    },

    mergeSameItems(items) {
      const mergedMap = new Map();
      
      items.forEach(item => {
          // 创建合并key，包含产品ID、规格ID、批次等关键字段
          const key = `${item.validityDate}_${item.specId}_${item.batch}_${item.longTime}_${item.billingPrice}_${item.supplierProductId}_${item.traceNo}_${item.mainNo}_${item.serialNo}_${item.manufactureDate}`;
          if (mergedMap.has(key)) {
              // 如果已存在相同项，则合并数量和金额
              const existing = mergedMap.get(key);
              existing.number += item.number;
              existing.amount += item.amount;
              existing.refundNumber += item.refundNumber;
              // 合并货位信息，用逗号分隔
              if (!existing.locationName.includes(item.locationName)) {
                  existing.locationName += `,${item.locationName}`;
              }
              
              // 合并ID数组，用于追踪原始记录
              if (!existing.mergedIds) {
                  existing.mergedIds = [existing.id];
              }
              existing.mergedIds.push(item.id);
          } else {
              // 不存在则添加到map中
              const newItem = {...item};
              if (newItem.locationName) {
                  newItem.originalLocationName = newItem.locationName; // 保留原始货位
              }
              mergedMap.set(key, newItem);
          }
      });
      
      // 返回合并后的数组
      return Array.from(mergedMap.values());
  },


    // change event
    applyChange (val) {
      var arr = this.applyList.filter(e => e.id == val)
      if (arr) {
        this.form.applyOutStockNo = arr[0].no
        this.form.applyOutStockId = arr[0].id
      }

      GetApplyOutStockById({ id: val })
        .then(res => {
          if (!res.successful) {
            this.$store.dispatch('SetLoading',false)
            return
          }
          let data = res.returnData
          if (data.applyWarehouseId) {
            // console.log(data.applyWarehouseId)
            this.form.warehouseId = data.applyWarehouseId
            this.form.warehouseName = data.applyWarehouseName
            this.form.warehouseManagerId = data.applyWarehouseManagerId

            // this.form.warehouseManagerName = data.warehouseManagerName
          }
          this.form.inStockDeptName = data.applyDeptName
          this.form.inStockDeptId = data.applyDeptId
          this.form.inStockWardId = data.wardId
          this.form.wardId = data.wardId
          this.form.category = data.category
          this.form.remark = data.remark
            console.log(data.billingDecoupled);
          // e.number- e.inStockNumber - e.packNumber
          if(this.system_setting.RfidIsApprovedManualStockIn==1||data.billingDecoupled==1){ // 库房是否解耦开关 billingDecoupled
            this.form.details = data.details
          }else{
          let arr = data.details.filter(e => e.refundNumber + e.packNumber + e.inStockNumber - e.icInStockNumber < e.number)
          
          let togetherCode = []
          arr.forEach((e,index)=>{
            let temp = e.tagCodeViewModels?.filter(item=>item.tagCodeType!=2)
            let temp1 = e.tagCodeViewModels?.filter(item=>item.tagCodeType==2&&item.minTagCode)
            temp1?.forEach(itme=>{
              togetherCode.push(itme.minTagCode)
            })
            if(temp?.length==0){
              arr.splice(index, 1);
              return
            }
            e.tagCodeViewModels = temp
            e.itemTagCodeViewModels?.forEach((r,i)=>{
              let temp2 = temp.filter(itme=>itme.itemTagCode==r.itemTagCode)
                 let num1 =0
              temp2?.forEach(itme=>{
                num1 += itme.number
              })
              if(num1==0){
                e.itemTagCodeViewModels?.splice(i, 1);
              }
              r.number = num1
            
            })
            let num =0
            temp1?.forEach(itme=>{
              num += itme.number
            })
            e.number =e.number - num
          })
          
          let set  =  new Set(togetherCode)
          let filterCode = Array.from(set);          
          arr.forEach(e => {
          e.tagCodeViewModels = e.tagCodeViewModels?.filter(tcv => !filterCode.includes(tcv.minTagCode));
          e.itemTagCodeViewModels?.forEach(r => {                        
            const matchedTags = e.tagCodeViewModels?.filter(tcv => tcv.itemTagCode == r.itemTagCode) ;
            const totalNumber = matchedTags.reduce((sum, tcv) => sum + tcv.number, 0);
            r.number = totalNumber;
          });
           let num =0
           e.tagCodeViewModels?.forEach(itme=>{
            num += itme.number
           })
           if(num != 0){
              e.number = num
           }
          });
          
          this.form.details = arr;

          }
         
          if (this.form.details && this.form.details.length > 0) {
            this.form.details = this.form.details.map((e, index) => {
              e.$index = index + 1
              e.locationId = ''
              e.locationName = ''
              // 入完柜子的  要减去已入柜数量          
              // 没入柜子的  就减去打包数量就可以了    
              // 入过柜子的   要把已经入的加回来 
              if(this.system_setting.RfidIsApprovedManualStockIn==1||data.billingDecoupled==1){  // 库房是否解耦开关 billingDecoupled
                e.number = e.number - e.inStockNumber - e.refundNumber  
              }else{
                e.number = e.number - e.refundNumber - e.packNumber - e.inStockNumber + e.icInStockNumber
              }
              e.amount = e.number * e.price
              e.refundNumber = 0
              return e
            }).filter((e) => e.number != 0); // 过滤掉数量为0的行
            this.form.details = this.mergeSameItems(this.form.details)
          }
          if (data.applyWarehouseId) {
            this.getLocations(data.applyWarehouseId)
          }
          this.autoTotalAmount()
        })
    },

    locationChange (row) {
      row.locationId = row.locationName
    },
    warehouseChange (val) {
      this.form.warehouseId = val
      let arr = this.STATIC_Warehouses.filter(item => item.id == val)
      this.form.warehouseName = arr[0].name
      this.form.warehouseManagerId = arr[0].managerId
      this.form.warehouseManagerName = arr[0].managerName
      this.getLocations(val)
    },



    getApplyList (keyWord) {
      let query = {
        keyWord: keyWord,
        pageIndex: 1,
        pageSize: 50,
        applyDeptId: this.mySessionStorage.getDeptId(), //this.userInfo.deptId,
        inStockStatus: 0,
        status: 2,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
        loginWardId:  this.system_setting.IsUseWard?this.mySessionStorage.getWardId():''
      }

      GetApplyOutStocks(query)
        .then(res => {
          this.applyList = res.returnData.data
        })
    },
    // getWarehouseList () {
    //   let query = {
    //     pageIndex: 1,
    //     pageSize: 50,
    //     state: 1,
    //     deptId: this.userInfo.deptId,
    //     loginDeptId: this.mySessionStorage.getDeptId(),
    //     loginWarehouseId: this.mySessionStorage.getWarehouseId()
    //   }
    //   GetWarehouses(query)
    //     .then(res => {
    //       this.warehouseList = res.returnData.data
    //     })
    // }
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}

/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
